import { Container, Row } from 'react-bootstrap';
import './callToAction.css';

function CallToAction(props) {
  const { leftContent, rightContent } = props;

  return (
    <section className="callToAction">
      <Container>
        <Row>
          {leftContent}
          {rightContent}
        </Row>
      </Container>
    </section>
  );
}

export default CallToAction;
